/* MTi Home V2 — testimonials carousel */
(function () {
  function initCarousel(root) {
    if (!root || root.dataset.hv2Init === '1') return;
    root.dataset.hv2Init = '1';
    var track = root.querySelector('.hv2-tst__track');
    var slides = track ? track.querySelectorAll('.hv2-tst__slide') : [];
    var dots = root.querySelectorAll('.hv2-tst__dot');
    var prevBtn = root.querySelector('[data-hv2-prev]');
    var nextBtn = root.querySelector('[data-hv2-next]');
    if (!track || !slides.length) return;

    var perViewDesktop = parseInt(root.dataset.perView || '3', 10);
    var interval = parseInt(root.dataset.interval || '5000', 10);
    var index = 0;
    var paused = false;
    var timer = null;

    function perView() { return window.innerWidth < 768 ? 1 : perViewDesktop; }
    function maxIndex() { return Math.max(0, slides.length - perView()); }
    function update() {
      var pv = perView();
      if (index > maxIndex()) index = 0;
      var gap = pv === 1 ? 12 : 20;
      var slidePct = 100 / pv;
      // each slide is calc(slidePct% - gap * (pv - 1) / pv)
      // translation: index * (slide width + gap)
      // slide width in px = (containerWidth * slidePct/100) - gap*(pv-1)/pv
      // But CSS uses % and px mix, so emulate the same formula
      track.style.transform = 'translateX(calc(' + (-index * slidePct) + '% - ' + (index * gap / pv) + 'px))';
      slides.forEach(function (s) {
        s.style.flex = '0 0 calc(' + slidePct + '% - ' + (gap * (pv - 1) / pv) + 'px)';
      });
      track.style.gap = gap + 'px';
      // dots
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.style.display = i <= maxIndex() ? '' : 'none';
      });
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex();
    }

    function go(n) { index = Math.max(0, Math.min(maxIndex(), n)); update(); }

    function tick() {
      if (paused) return;
      index = (index + 1) > maxIndex() ? 0 : (index + 1);
      update();
    }

    function startTimer() { stopTimer(); if (interval > 0) timer = setInterval(tick, interval); }
    function stopTimer() { if (timer) { clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); });
    });
    window.addEventListener('resize', update);
    update();
    startTimer();
  }

  function bootstrap() {
    document.querySelectorAll('[data-hv2-testimonials]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', bootstrap);
})();
